import { useGetOne } from 'react-admin';
import { METADATA_AVATAR_TYPES } from '@/utils/CONST';

interface Params {
    metadataAvatarTypeUriId: string;
}

const useGetMetadataAvatarType = ({ metadataAvatarTypeUriId }: Params) => {
    const { data, isLoading, refetch }: any = useGetOne(
        METADATA_AVATAR_TYPES,
        {
            id: metadataAvatarTypeUriId,
        },
        {
            enabled: metadataAvatarTypeUriId !== undefined && metadataAvatarTypeUriId !== null,
        },
    );

    return {
        metadataAvatarType: data,
        isLoading,
        refetch,
    };
};

export default useGetMetadataAvatarType;
